import React from 'react';
import { Box, Button } from '@mui/material';
import Chip from '../primitives/Chip';
import type { ActiveFilter } from '@/shared/hooks/useListFilters';

export interface FilterChipsProps<K extends string = string> {
  items: ActiveFilter<K>[];
  onRemove: (key: K) => void;
  onClearAll?: () => void;
}

function FilterChips<K extends string = string>({
  items,
  onRemove,
  onClearAll,
}: FilterChipsProps<K>): React.JSX.Element | null {
  if (items.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
      {items.map((item) => (
        <Chip
          key={item.key}
          label={`${item.label}: ${item.displayValue}`}
          size="small"
          onDelete={() => onRemove(item.key)}
        />
      ))}
      {items.length > 1 && onClearAll && (
        <Button size="small" onClick={onClearAll} sx={{ minWidth: 0, px: 1 }}>
          Xóa tất cả
        </Button>
      )}
    </Box>
  );
}

export default FilterChips;
